import React, { ReactNode } from "react";
import classNames from "classnames";

interface ModalBodyProps {
  children: ReactNode;
  className?: string;
  fixed?: boolean;
}

const ModalBody: React.FC<ModalBodyProps> = ({
  children,
  className = "",
  fixed = false,
}) => {
  return (
    <div
      className={classNames({
        "p-3": true,
        "overflow-auto grow border-y": !fixed,
        [className]: className,
      })}
    >
      {children}
    </div>
  );
};

export default ModalBody;
